export const API_ENDPOINTS = {
  DS: {
    GET_DS_LIST: "/DsV2/GetDsList",
    GET_UPDATE: "/DsV2/GetUpdateV2",
    GET_DS_PROCESS: "/DsV2/GetDsProcess",
    SEND_PLAYER_STAT: "/DsV2/PlayerStat",
  },
  AUTH: {
    CODE_REQUEST: "/Authentication/CodeRequest",
    CODE_LOGIN: "/Authentication/CodeLogin",
    UPDATE_PASSWORD: "/Authentication/UpdateMyPassword",
    FORGOT_PASSWORD: "/Authentication/ForgetMyPassword",
  },
  USER: {
    RIGHTS: "/UserRight",
    FIRM_LIST: "/UserRight/GetMyFirmList",
    GET: "/User",
    GET_DETAILS: "/User/GetDetails",
    UPDATE: "/User/Update",
    ADD: "/User/Add",
    DELETE: "/User/Delete",
    GET_USER_FIRM: "/User/GetUserFirm",
    ADD_USER_FIRM: "/User/AddFirm",
    DELETE_USER_FIRM: "/User/DeleteFirm",
    GET_UNREAD_NOTIFICATION_COUNT: "/User/GetUnreadNotificationCount",
  },
  APP_USER_ROLE: {
    GET: "/AppUserRole",
    ADD: "/AppUserRole/Add",
    DELETE: "/AppUserRole/Delete",
  },
  LOG: {
    AUDIT: "/Log/AuditLog",
    LOGIN: "/Log/LoginLog",
    TRACE: "/Log/TraceLog",
  },
  CURRENCY: "/Currency",
  PUBLISH: "/Publish",
  FIRM_LICENCES: {
    GET: "/FirmLicence",
    REMOVE: "/FirmLicence/RemoveAssignedLicence",
    ASSIGN_WEBLINK: "/FirmLicence/AssignWebLinkLicence",
    UPDATE_DEVICE_NAME: "/FirmLicence/UpdateDeviceName",
    REMOVE_ASSIGNED_GROUP_CONTENT: "/FirmLicence/RemoveAssignedGroupContent",
    DELETE: "/FirmLicence/Delete",
    REQUEST_NEW_LICENCE: "/FirmLicence/RequestNewLicence",
  },
  FIRM_API_TOKEN: {
    GET: "/FirmAPIToken/GetFirmAPI",
    REGISTER: "/FirmAPIToken/RegisterFirmAPI",
  },
  FIRM: {
    GET: "/Firm",
    ADD: "/Firm/Add",
    UPDATE: "/Firm/Update",
    DELETE: "/Firm/Delete",
    GET_DETAILS: "/Firm/GetDetails",
    ADD_LICENCE: "/Firm/AddLicence",
    GET_DASHBOARD: "/Firm/GetFirmDashboard",
    SEARCH: "/Firm/Search",
    CHANGE_LICENCE_EXPIRY: "/Firm/ChangeLicenceExpiry",
  },
  CONTENT: {
    GET: "/Content",
    DELETE: "/Content/Delete",
    UPLOAD: "/Content/UploadContent",
    UPLOAD_WITHOUT_CONTENT: "/Content/UploadWithoutContent",
    UPDATE_FOLDER: "/Content/UpdateFolder",
    ADD_CONTENT: "/Content/AddContent",
    UPDATE_CONTENT_DATES: "/Content/UpdateContentDates",
    UPDATE_CONTENT_LINK: "/Content/UpdateContentLink",
    CONTENT_UPDATE_SIZES: "/Content/ContentUpdateSizes",
    CONTENT_RENAME: "/Content/Update",
    GET_DETAILS: "/Content/GetDetails",
    UPDATE_CONTENT_FILE: "/Content/UpdateContent",
  },
  CONTENT_TAG: {
    GET: "/ContentTag",
    DELETE: "/ContentTag/Delete",
    ADD: "/ContentTag/Add",
  },
  TAG: {
    GET: "/Tag",
    GET_DETAILS: "/Tag/GetDetails",
    ADD: "/Tag/Add",
    DELETE: "/Tag/Delete",
    UPDATE: "/Tag/Update",
  },
  FOLDER: {
    GET: "/Folder",
    ADD: "/Folder/Add",
    UPDATE: "/Folder/UpdateNameAndColor",
    ORDER: "/Folder/UpdateOrder",
    UPDATE_MAIN_FOLDER: "/Folder/UpdateMainFolder",
    DELETE: "/Folder/Delete",
  },
  CONTENT_GROUP: {
    GET: "/ContentGroup",
    ADD: "/ContentGroup/Add",
    GET_DETAILS: "/ContentGroup/GetDetails",
    UPDATE: "/ContentGroup/Update",
    DELETE: "/ContentGroup/Delete",
  },
  CONTENT_GROUP_TAG: {
    GET: "/ContentGroupTag",
    ADD: "/ContentGroupTag/Add",
    DELETE: "/ContentGroupTag/Delete",
  },
  CONTENT_GROUP_MEMBER: {
    GET: "/ContentGroupMember",
    ADD: "/ContentGroupMember/Add",
    DELETE: "/ContentGroupMember/Delete",
    UPDATE: "/ContentGroupMember/Update",
  },
  CONTENT_GROUP_MEMBER_CATEGORY: {
    GET: "/ContentGroupMemberCategory",
    ADD: "/ContentGroupMemberCategory/Add",
    DELETE: "/ContentGroupMemberCategory/Delete",
    UPDATE: "/ContentGroupMemberCategory/Update",
    GET_DETAILS: "/ContentGroupMemberCategory/GetDetails",
  },
  ROLE: {
    GET: "/Role",
    GET_DETAILS: "/Role/GetDetails",
    ADD: "/Role/Add",
    UPDATE: "/Role/Update",
    DELETE: "/Role/Delete",
  },
  MENU: {
    GET: "/Menu",
    GET_DETAILS: "/Menu/GetDetails",
    ADD: "/Menu/Add",
    DELETE: "/Menu/Delete",
    UPDATE: "/Menu/Update",
  },
  MENU_HEADER: {
    GET: "/MenuHeader",
    GET_DETAILS: "/MenuHeader/GetDetails",
    ADD: "/MenuHeader/Add",
    DELETE: "/MenuHeader/Delete",
    UPDATE: "/MenuHeader/Update",
  },
  MENU_HEADER_MEMBER: {
    GET: "/MenuHeaderMember",
    ADD: "/MenuHeaderMember/Add",
    DELETE: "/MenuHeaderMember/Delete",
  },
  ROLE_MENU: {
    GET: "/RoleMenu",
    DELETE: "/RoleMenu/Delete",
    ADD: "/RoleMenu/Add",
  },
  ENTITY: {
    GET: "/Entity",
  },
  MENU_ENTITY: {
    GET: "/MenuEntity",
    ADD: "/MenuEntity/Add",
    DELETE: "/MenuEntity/Delete",
    UPDATE: "/MenuEntity/Update",
  },
  ENUM: {
    RIGHT: {
      GET: "/Enum/Right",
    },
  },
  ALLERGY: {
    GET: "/Allergy",
    GET_DETAILS: "/Allergy/GetDetails",
    ADD: "/Allergy/Add",
    UPDATE: "/Allergy/Update",
    DELETE: "/Allergy/Delete",
  },
  STORE: {
    GET: "/Store",
    GET_DETAILS: "/Store/GetDetails",
    ADD: "/Store/Add",
    UPDATE: "/Store/Update",
    DELETE: "/Store/Delete",
  },
  STORE_SALE_PACK: {
    GET: "/StoreSalePack",
    ADD: "/StoreSalePack/Add",
    DELETE: "/StoreSalePack/Delete",
  },
  HOSPITALITY_MENU: {
    GET: "/HMenu",
    GET_DETAILS: "/HMenu/GetDetails",
    ADD: "/HMenu/Add",
    UPDATE: "/HMenu/Update",
    DELETE: "/HMenu/Delete",
    SYNC: "/HMenu/Sync",
    REMOVE_CATEGORY: "/HMenu/RemoveCategory",
  },
  HOSPITALITY_MENU_FILE: {
    GET: "/HMenuFile",
    UPLOAD: "/HMenuFile/UploadFile",
  },
  HOSPITALITY_MENU_CATEGORY: {
    GET: "/HMenu/GetCategories",
    UPDATE_NAME: "/HMenu/UpdateCategoryName",
    UPDATE_ORDER: "/HMenu/UpdateCategoryOrder",
    ADD: "/HMenu/AddCategory",
  },
  HOSPITALITY_MENU_CATEGORY_ITEM: {
    GET: "/HMenuItem",
    ADD: "/HMenuItem/Add",
    UPDATE: "/HMenuItem/Update",
    DELETE: "/HMenuItem/Delete",
  },
  HOSPITALITY_MENU_CATEGORY_ITEM_FILE: {
    GET: "/HMenuItemFile",
    UPLOAD: "/HMenuItemFile/UploadFile",
  },
  HOSPITALITY_MENU_ITEM_ALLERGY: {
    GET: "/HMenuItemAllergy",
    ADD: "/HMenuItemAllergy/Add",
    DELETE: "/HMenuItemAllergy/Delete",
  },
  TEMPLATE: {
    GET: "/DsTemplate",
    GET_DETAILS: "/DsTemplate/GetDetails",
    ADD: "/DsTemplate/Add",
    UPDATE: "/DsTemplate/Update",
    DELETE: "/DsTemplate/Delete",
  },
  STOCK_TEMPLATE: {
    GET: "/DsStockTemplate",
    GET_DETAILS: "/DsStockTemplate/GetDetails",
    ADD: "/DsStockTemplate/Add",
    UPDATE: "/DsStockTemplate/Update",
    DELETE: "/DsStockTemplate/Delete",
  },
  SCREEN_SIZE: {
    GET: "/ScreenSize",
    GET_DETAILS: "/ScreenSize/GetDetails",
    ADD: "/ScreenSize/Add",
    UPDATE: "/ScreenSize/Update",
    DELETE: "/ScreenSize/Delete",
  },
  PLAYER: {
    GET: "/Player",
    GET_DETAILS: "/Player/GetDetails",
    ADD: "/Player/Add",
    UPDATE: "/Player/Update",
    DELETE: "/Player/Delete",
    ASSIGN_LICENCE: "/Player/AssignLicence",
    REGISTER_CODE: "/Player/RegisterCode",
    GET_ALL_PLAYER_DETAILS: "/Player/GetAllPlayerDetails",
    PLAYER_SYNC: "/Player/PlayerSync",
    PLAYER_SYNC_STATUS: "/Player/PlayerSyncStatus",
    GET_PLAYER_HEALTH: "/Player/GetPlayerHealth",
    PLAYER_RESTART: "/Player/PlayerRestart",
    GET_PLAYER_STATS: "/Player/GetPlayerStats",
  },
  PLAYER_TAG: {
    GET: "/PlayerTag",
    ADD: "/PlayerTag/Add",
    DELETE: "/PlayerTag/Delete",
  },
  CHANNEL: {
    GET: "/Channel",
    GET_DETAILS: "/Channel/GetDetails",
    ADD: "/Channel/Add",
    UPDATE: "/Channel/Update",
    DELETE: "/Channel/Delete",
  },
  CHANNEL_TAG: {
    GET: "/ChannelTag",
    ADD: "/ChannelTag/Add",
    DELETE: "/ChannelTag/Delete",
  },
  CHANNEL_DETAIL: {
    GET: "/ChannelDetail",
    GET_DETAILS: "/ChannelDetail/GetDetails",
    ADD: "/ChannelDetail/Add",
    UPDATE: "/ChannelDetail/Update",
    DELETE: "/ChannelDetail/Delete",
  },
  CHANNEL_DETAIL_CONTENT: {
    GET: "/ChannelDetailContent",
    ADD: "/ChannelDetailContent/Add",
    DELETE: "/ChannelDetailContent/Delete",
  },
  CHANNEL_DETAIL_DATE: {
    GET: "/ChannelDetailDate",
    GET_DETAILS: "/ChannelDetailDate/GetDetails",
    ADD: "/ChannelDetailDate/Add",
    UPDATE: "/ChannelDetailDate/Update",
    DELETE: "/ChannelDetailDate/Delete",
  },
  AREA: {
    GET: "/Area",
    GET_DETAILS: "/Area/GetDetails",
    ADD: "/Area/Add",
    UPDATE: "/Area/Update",
    DELETE: "/Area/Delete",
  },
  AREA_TYPE: {
    GET: "/AreaType",
    GET_DETAILS: "/AreaType/GetDetails",
    ADD: "/AreaType/Add",
    UPDATE: "/AreaType/Update",
    DELETE: "/AreaType/Delete",
  },
  AREA_CONTENT: {
    GET: "/AreaContent",
    ADD: "/AreaContent/Add",
    DELETE: "/AreaContent/Delete",
  },
  CAMPAIGN: {
    GET: "/Campaign",
    GET_DETAILS: "/Campaign/GetDetails",
    ADD: "/Campaign/Add",
    UPDATE: "/Campaign/Update",
    DELETE: "/Campaign/Delete",
  },
  CAMPAIGN_CONDITION: {
    GET: "/CampaignCondition",
    ADD: "/CampaignCondition/Add",
    DELETE: "/CampaignCondition/Delete",
    UPDATE: "/CampaignCondition/Update",
    GET_DETAILS: "/CampaignCondition/GetDetails",
  },
  CAMPAIGN_TAG: {
    GET: "/CampaignTag",
    ADD: "/CampaignTag/Add",
    DELETE: "/CampaignTag/Delete",
  },
  CAMPAIGN_DETAIL: {
    GET: "/CampaignDetail",
    GET_DETAILS: "/CampaignDetail/GetDetails",
    ADD: "/CampaignDetail/Add",
    UPDATE: "/CampaignDetail/Update",
    DELETE: "/CampaignDetail/Delete",
  },
  CAMPAIGN_DETAIL_CONTENT: {
    GET: "/CampaignDetailContent",
    ADD: "/CampaignDetailContent/Add",
    DELETE: "/CampaignDetailContent/Delete",
  },
  CAMPAIGN_DETAIL_DATE: {
    GET: "/CampaignDetailDate",
    GET_DETAILS: "/CampaignDetailDate/GetDetails",
    ADD: "/CampaignDetailDate/Add",
    UPDATE: "/CampaignDetailDate/Update",
    DELETE: "/CampaignDetailDate/Delete",
  },
  PLAYER_CAMPAIGN: {
    GET: "/PlayerCampaign",
  },
  AREA_CAMPAIGN: {
    GET: "/AreaCampaign",
    ADD: "/AreaCampaign/Add",
    DELETE: "/AreaCampaign/Delete",
    GET_BY_CAMPAIGN: "/AreaCampaign/GetByCampaign",
  },
  API: {
    GET: "/Api",
  },
  MENU_API: {
    GET: "/MenuApi",
    ADD: "/MenuApi/Add",
    DELETE: "/MenuApi/Delete",
  },
  BLOG_POST: {
    GET: "/BlogPost",
    GET_DETAILS: "/BlogPost/GetDetails",
    ADD: "/BlogPost/Add",
    UPDATE: "/BlogPost/Update",
    DELETE: "/BlogPost/Delete",
  },
  NOTIFICATION: {
    GET: "/Notification",
    UPSERT_NOTIFICATION_TOKEN: "/Notification/UpsertNotificationToken",
    MARK_ALL_READ: "/Notification/MarkAllRead",
  },
  SYSTEM_USER_DYNAMIC_SETTING: {
    GET: "/SystemUserDynamicSetting",
    GET_FOR_USER: "/SystemUserDynamicSetting/GetSystemUserDynamicSettings",
    ADD: "/SystemUserDynamicSetting/AddSystemUserDynamicSetting",
    REMOVE: "/SystemUserDynamicSetting/RemoveSystemUserDynamicSetting",
  },
  USER_SUB_ADMIN: {
    GET: "/UserSubAdmin",
    ADD: "/UserSubAdmin/Add",
    DELETE: "/UserSubAdmin/Delete",
    GET_DETAILS: "/UserSubAdmin/GetDetails",
    UPDATE: "/UserSubAdmin/Update",
  },
} as const;
